import { Schema, defineTable } from 'squid';
export const jobServiceTable = defineTable('job_service', {
    job_id: Schema.String,
    type: Schema.String,
});
